import { nanoid } from 'nanoid';

export const nid = () => nanoid();